
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

@media (min-width: 1280px) {

  :host {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {

  :host {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
}

ul {
  margin: 0px;
  display: flex;
  list-style-type: none;
  padding: 0px;
}

.header-utility {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1.5rem;
}

.header-utility ul li {
  margin: 0px;
}

.header-utility ul li {
  padding: 0px;
}

.header-utility a{
    --outline-link-color-default:var(--blue-responsible-darken-2);
    --outline-link-color-hover:var(--blue-responsible-darken-1);
    --outline-link-color-focus:var(--blue-responsible-darken-1);
  }

@media (min-width: 1024px) {

  .footer-utility {
    display: flex;
  }

  .footer-utility {
    flex-direction: row;
  }

  .footer-utility {
    place-content: center;
  }

  .footer-utility {
    justify-content: space-around;
  }
}

.footer-utility ul {
  flex-direction: column;
}

@media (min-width: 1024px) {

  .footer-utility ul {
    flex-direction: row;
  }
}

.footer-utility ul li {
  margin-top: 0px;
  margin-bottom: 0px;
}

.footer-utility ul li {
  margin-left: 0px;
  margin-right: 0px;
}

.footer-utility ul li {
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 1024px) {

  .footer-utility ul li {
    margin-right: 2rem;
  }
}

@media (min-width: 1024px) {

  .footer-utility ul li {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.footer-utility ul li:last-of-type {
  margin-right: 0px;
}

.footer-utility ul li a{
        --outline-link-color-hover:var(--gray-professional-lighten-3);
      }

.footer-utility ul li a {
  display: block;
}

.footer-utility ul li a {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.footer-utility ul li a {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.footer-utility ul li a {
  color: var(--neutral-white);
}

@media (min-width: 1024px) {

  .footer-utility ul li a {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

@media (min-width: 1024px) {

  .footer-utility ul li a {
    padding-left: 0px;
    padding-right: 0px;
  }
}

a {
  color: var(--blue-responsible-darken-2);
}

a:hover {
  color: var(--blue-responsible-darken-1) !important;
}

@media screen and (max-width: 1024px){
    .footer-utility ul {
    display: flex;
  }
    .footer-utility ul {
    flex-direction: row;
  }
    .footer-utility ul {
    flex-wrap: wrap;
  }
      .footer-utility ul li {
    margin-top: 0px;
    margin-bottom: 0px;
  }
      .footer-utility ul li {
    margin-left: 0px;
    margin-right: 0px;
  }
      .footer-utility ul li {
    width: 50%;
  }
      .footer-utility ul li:nth-of-type(3n) {
    width: 100%;
  }
}
`;